import { mapState } from 'vuex';
import ButtonComponent from '@/sharedcomponents/baseComponents/buttonComponent/buttonComponent.vue';
import ModalComponent from '@/sharedcomponents/baseComponents/ModalComponent/ModalComponent.vue';
import { Options, Vue } from 'vue-class-component';
import store from '@/store/store';
import { nextTick } from '@vue/runtime-core';

@Options({
	name: 'ToggleModalComponent',
	components: {
		ModalComponent,
		ButtonComponent,
	},
	computed: mapState<any>({
		modal: (state) => store.state.modal,
	}),
})
export default class ToggleModalComponent extends Vue {
	public modal: any;

	mounted() {
		store.subscribeAction((action, state) => {
			if (action.type === 'toggleModal') {
				if (!action.payload.isActive) {
					this.modal.show = false;
					// Check if close modal should redirect
					const redirect = this.modal.redirect;
					if (redirect) {
						store.state.showSpinner = true;
						location.href = redirect;
					}
				}
			}
		});
	}
	public get showModal() {
		if (this.modal.show) {
			// trigger
			nextTick(() => {
				store.dispatch('toggleModal', {
					isActive: this.modal.show,
					id: this.modal.id,
				});
			});
		} else {
			// Hack to Fix scrollbar missing
			(document.body as HTMLElement).style.overflow = 'initial';
		}
		return !!this.modal.show;
	}

	public closeModal() {
		store.dispatch('toggleModal', { show: false, id: this.modal.id });
	}

	public btnAction() {
		if (this.modal.btnAction) {
			this.$router.push(this.modal.btnAction);
		} else {
			store.dispatch('toggleModal', { show: false, id: this.modal.id });
		}
	}

	public handleInlineAction() {
		if (typeof this.modal.btnInlineAction == 'function') {
			this.modal.btnInlineAction();
		} else {
			this.$router.push(this.modal.btnInlineAction);
		}
	}
}
